import React from 'react';

const Title = () =>{
    return(
        <>
        <div className='mt-10 mb-5' id="title">
            <h1 className="text-5xl font-bold mb-1">CodeOne</h1>
            <h3 className="text-2xl ">Write Codes. Be Awesome</h3>
        </div>
        <div>
            <hr/>
        </div>
        </>
        
    )
}
export default Title